// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__19R4g","containerItemsCenter":"Skeleton_containerItemsCenter__3YtlP"};